module.exports = __webpack_public_path__ + "img/165.13936724.png";